import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Shelf, Grid } from "capitalrx-components-2.0/lib/layout";
import "./Footer.scss";

export const Footer: FC = () => {
  const { t: translate } = useTranslation();
  return (
    <div className="enrollment-footer-container">
      <Grid>
        <Grid.Span columns={1} />
        <Grid.Span columns={10}>
          <Shelf>
            <div>© {new Date().getFullYear()} Capital Rx</div>
            <Shelf.Spacer />
            <a href="https://www.cap-rx.com/legal#legal-notice-privacy-policy">{translate("FOOTER.legalNotices")}</a>
          </Shelf>
        </Grid.Span>
        <Grid.Span columns={1} />
      </Grid>
    </div>
  );
};
